import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators,FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AlertService } from 'src/app/providers/alert.service';
import { ApiService } from 'src/app/providers/api.service';
import { AuthService } from 'src/app/providers/auth.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { StorageService } from 'src/app/providers/storage.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { COUNTRY_CODES } from 'src/app/shared/data/country-codes';
import { CustomConfirmDialogComponent } from '../custom-confirm-dialog/custom-confirm-dialog.component';

@Component({
  selector: 'sm-change-number',
  templateUrl: './change-number.component.html',
  styleUrls: ['./change-number.component.scss']
})
export class ChangeNumberComponent implements OnInit, OnDestroy {
  otp: string[] = ['', '', '', '', '', ''];
  toShowFinal: boolean = false
  @ViewChild('submitButton', {read: ElementRef ,static: true})
  submitButton!: ElementRef<HTMLButtonElement>;
  signInForm!: FormGroup;
  countryList: {name: string; dial_code: string; code: string; flag: string; preferred?: any;}[] = COUNTRY_CODES;
  countryCode: FormControl;
  phoneControl: FormControl;
  sendingOtpStatus: boolean = false;
  phone:any
  otpReceived: boolean = false;
  cinput: any = ''
  private _apiSubscription: Subscription;
  searchString: FormControl = new FormControl('');

  constructor(
    private _navService: NavigationService,
    private _router: Router,
    private _authService: AuthService,
    private _alertService: AlertService,
    private _apiService: ApiService,
    private _storageService: StorageService,
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private dialog: MatDialog
  ) {
    // this._navService.hideSidebarAndNav = true;
    this.countryCode = new FormControl(this.countryList.find(country => country.dial_code === '+91'), Validators.required);
    this.selectedCountry = this.countryList.find(country => country.dial_code === '+91')
    this.phoneControl = new FormControl('', [Validators.required, Validators.minLength(10)]);

    this._apiSubscription = this._apiService.apiResult.subscribe(resData => {
      if (resData.responseType === SM_CONSTANTS.CHECK_USER_RESULT) {
        console.log(resData);
        if(resData.result){
          this._storageService.setLocalStorageValue(SM_CONSTANTS.KEY_ACCOUNT_PHONE_NUMBER, this.userPhoneNumber)
        
        if (resData.result.errorcode === 1) {
          this._storageService.setLocalStorageValue(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID, resData.result.accountHashID);
          this._router.navigateByUrl('/dashboard').then(_ => {
            this._alertService.onOpenSnackbar('Logged in successfully');
          });
          this.sendingOtpStatus = false;
        } 
        else if(resData.result.errorcode === 0){
          this._storageService.setLocalStorageValue(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID, resData.result.accountHashID);
          this._router.navigate(["/registration"])
          this.sendingOtpStatus = false;
        } 
        else {
          this._alertService.onOpenSnackbar(resData.result.message, 4000);
          this.sendingOtpStatus = false;

        }
      }
      }
    });
  }

  onKey() { 
    console.log(this.searchString.value);
    
    this.countryList= []; 
    this.selectSearch(this.searchString.value);       
}

onCountrySelected(event: any): void {
  this.searchString.reset()
  this.countryList = COUNTRY_CODES
}
checkOtpDisability(){
  let isDisable = false
  this.otp.forEach(item => {
    if(!item || item == ''){
      isDisable = true
    }
  })

  return isDisable
}
onSelectOpened(opened: boolean): void {
  const panel = document.querySelector('.mat-select-panel') as HTMLElement;
  const fixedPanel = document.querySelector('.mat-select-panel-fixed') as HTMLElement;

  if (panel && fixedPanel) {
    if (opened) {
      fixedPanel.style.display = 'block';
      panel.classList.add('mat-select-panel-fixed');
    } else {
      fixedPanel.style.display = 'none';
      panel.classList.remove('mat-select-panel-fixed');
    }
  }
}


selectSearch(value:string){
  let filter = value.toLowerCase();
  for ( let i = 0 ; i < COUNTRY_CODES.length; i ++ ) {
      let option = COUNTRY_CODES[i];
      if (  option.name.toLowerCase().indexOf(filter) >= 0) {
          this.countryList.push( option );
      }
  }
}

  ngOnInit(): void {
    this.signInForm = new FormGroup({
      'country': this.countryCode,
      'phone': this.phoneControl,
      'otp': new FormControl('', [Validators.required, Validators.minLength(6)])
    });
    this._authService.initRecaptcha(this.submitButton.nativeElement)

  }

  onInput(event: any, index: number) {
    const input = event.target as HTMLInputElement;
    if (input.value.length === 1 && index < 5) {
      const nextInput = document.getElementById(`box${index + 1}`);
      
      nextInput?.focus();
    } else if (input.value.length === 0 && index > 0) {
      const prevInput = document.getElementById(`box${index - 1}`);
      prevInput?.focus();
    }
  }


  onSendOTP(){
    this.otp = ['', '', '', '', '', '']
    console.log(this.userPhoneNumber);
    this.sendingOtpStatus = true;
    this._authService.onReceiveOTP(this.userPhoneNumber).then(res =>{

      this.sendingOtpStatus = !res;
      this.otpReceived = res;
      this.toShowFinal = true
      const element = document.getElementById('first-form1');
      if (element) {
        element.style.display = 'none';
      }
      setTimeout(() => {
        const nextInput = document.getElementById('box0');
        nextInput?.focus();
        
      }, 1);
    });
  }
  selectedCountry: any;
  public get userPhoneNumber(){
    return (this.selectedCountry.dial_code + this.phone.toString());
  }
  public get newUserPhoneNumber(){
    return (this.phone.toString());
  }
  
  // onSignIn(){
  //   this.sendingOtpStatus = true;
  //   this._authService.onSignInWithPhone(this.signInForm.value['otp']).then(res =>{
  //     if(res){
  //       // console.log(res);
  //       const apiBodyData = {
  //         versionCode: '1.0.0',
  //         appType: 'web'
  //       }
  //       this._apiService.checkUser(apiBodyData, res.user.uid, this.userPhoneNumber);
  //       }
  //   });
  // }


  ngOnDestroy(){
    this._apiSubscription.unsubscribe();
  }

  changePhoneNumber(){
    this.sendingOtpStatus = true;
    const otpValue = this.otp.join('');
    console.log(otpValue);
    
    this._authService.changePhoneNumber(otpValue).then(res => {
        console.log('changephone res', JSON.stringify(res));
        this.parentData.ref.closeAll()
        this._authService.onSignOutAfterPhoneChange()
        

    })
    .catch(err => {
      this.signInForm.get('otp')?.patchValue('')
      this.otpReceived = false
      this.sendingOtpStatus = false;
      const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
        data : {
          title : 'Alert',
          message : 'This phone number is already associated with an active Lookzup account. Please try with a different phone number.',
          okbtn : 'Ok',
          cancelbtn : 'Cancel',
          type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
        },
        disableClose : true
      });
    })
  }

  checkUser(){
    // this.sendingOtpStatus = true;
    this._authService.check().then(res =>{
      if(res){
        console.log(res);
        // const apiBodyData = {
        //   versionCode: '1.0.0',
        //   appType: 'web'
        // }
        // this._apiService.checkUser(apiBodyData, res.user.uid, this.userPhoneNumber);
        }
    });
  }
  deleteUser(){
    // this.sendingOtpStatus = true;
    this._authService.delete().then(res =>{
      if(res){
        console.log(res);
        // const apiBodyData = {
        //   versionCode: '1.0.0',
        //   appType: 'web'
        // }
        // this._apiService.checkUser(apiBodyData, res.user.uid, this.userPhoneNumber);
        }
    });
  }
}

